import { useState } from "react";
import { fa } from "./data";

function AddGroupModal({ onCancel, onSave }) {
  const [name, setName] = useState("");
  const [error, setError] = useState("");

  async function handleSubmit(e) {
    e.preventDefault();
    setError("");
    const result = await onSave(name);
    if (result?.error) setError(result.error);
  }

  return (
    <div className="modal-bg" style={{ display: "block" }} onClick={(e) => { if (e.target === e.currentTarget) onCancel(); }}>
      <section className="modal" role="dialog" aria-modal="true">
        <h3>افزودن گروه جدید</h3>
        <p className="entity-modal-note">نام گروه را وارد کنید. گروه جدید به انتهای فهرست اضافه می‌شود.</p>
        <label className="sr-only" htmlFor="newGroupName">نام گروه</label>
        <input
          id="newGroupName"
          className="input"
          placeholder="مثلاً روابط عمومی"
          autoComplete="off"
          value={name}
          onChange={(e) => setName(e.target.value)}
          onKeyDown={(e) => { if (e.key === "Enter") handleSubmit(e); }}
          autoFocus
        />
        {error && <div className="login-error">{error}</div>}
        <div className="modal-actions">
          <button className="btn" type="button" onClick={onCancel}>انصراف</button>
          <button className="btn btn-primary" type="button" onClick={handleSubmit}>ذخیره</button>
        </div>
      </section>
    </div>
  );
}

export default function GroupsPage({ groups, people, canManageGroups, canUpdate, canDelete, onBack, onAddGroup, onRenameGroup, onDeleteGroup }) {
  const [modalOpen, setModalOpen] = useState(false);

  function memberCount(groupId) {
    return people.filter(p => String(p.group_id) === String(groupId)).length;
  }

  return (
    <main className="app-shell">
      <header className="topbar">
        <div className="brand">
          <div className="brand-copy">
            <div className="page-title">گروه‌های کارشناسان</div>
          </div>
        </div>
        <div className="top-actions">
          {canManageGroups && (
            <button className="btn btn-primary" type="button" onClick={() => setModalOpen(true)}>＋ افزودن گروه جدید</button>
          )}
          <button className="btn btn-soft" type="button" onClick={onBack}>بازگشت به پنل مدیریت</button>
        </div>
      </header>

      <section className="hero">
        <div className="hero-line">
          <div>
            <h1>مدیریت گروه‌ها</h1>
            <p>گروه جدید اضافه کنید یا نام گروه‌های غیرسیستمی را تغییر دهید و حذف کنید.</p>
          </div>
        </div>
      </section>

      <section className="groups">
        {groups.map(g => (
          <article className="person" key={g.id}>
            <div className="user-row">
              <div>
                <div className="name">{g.name}</div>
                <div className="meta">{fa(memberCount(g.id))} کارشناس{g.system ? " · گروه سیستمی" : ""}</div>
              </div>
              {!g.system && (canUpdate || canDelete) && (
                <div className="user-actions">
                  {canUpdate && <button className="small" type="button" onClick={() => onRenameGroup(g.id)}>تغییر نام</button>}
                  {canDelete && <button className="small danger" type="button" onClick={() => onDeleteGroup(g.id)}>حذف</button>}
                </div>
              )}
            </div>
          </article>
        ))}
        {!groups.length && <div className="empty">هنوز گروهی ثبت نشده است.</div>}
      </section>

      {modalOpen && canManageGroups && (
        <AddGroupModal
          onCancel={() => setModalOpen(false)}
          onSave={async (name) => {
            const result = await onAddGroup(name);
            if (!result?.error) setModalOpen(false);
            return result;
          }}
        />
      )}
    </main>
  );
}
